/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type React from 'react';

import { _date, _fn } from '@mairistem/administres-utils';
import { Table } from '@mairistem/composants';

import type { Acte, TypeActe } from '@/types';

import ActeTableLineDeces from './ActeTableLineDeces';
import ActeTableLineMariage from './ActeTableLineMariage';
import ActeTableLineNaissance from './ActeTableLineNaissance';
import ActeTableLinePacs from './ActeTableLinePacs';
import ActeTableLineReconnaissance from './ActeTableLineReconnaissance';

interface Props {
  acte: Acte;
  typeActe: TypeActe;
  active?: boolean;
  onSelected?: (acte: Acte) => void;
}

const ActeTableLine = (props: Props) => {
  const { acte, typeActe, active, onSelected } = props;

  let cells: (p: { acte: Acte }) => React.ReactNode;

  switch (typeActe) {
    case 'naissance':
    case 'decision':
      cells = ActeTableLineNaissance;
      break;
    case 'reconnaissance':
      cells = ActeTableLineReconnaissance;
      break;
    case 'mariage':
      cells = ActeTableLineMariage;
      break;
    case 'deces':
      cells = ActeTableLineDeces;
      break;
    case 'pacs':
      cells = ActeTableLinePacs;
      break;
    default:
      cells = () => undefined;
      break;
  }

  return (
    <Table.Row
      selectable
      active={active}
      onClick={() => _fn(onSelected, acte)}
      style={{ cursor: 'pointer' }}
    >
      <Table.Cell content={acte.anneeActe} />
      <Table.Cell content={acte.numeroActe} />
      {typeActe !== 'pacs' && (
        <Table.Cell content={_date.short(acte.dateDresseActe)} />
      )}
      {cells({ acte })}
    </Table.Row>
  );
};

export default ActeTableLine;
